import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const projects = [
  { src: "./2.jpg", alt: "Projekt 1" },
  { src: "./3.jpg", alt: "Projekt 2" },
  { src: "./4.jpg", alt: "Projekt 3" },
  { src: "./5.jpg", alt: "Projekt 4" },
  { src: "./6.jpg", alt: "Projekt 5" },
  { src: "./7.jpg", alt: "Projekt 6" },
  { src: "./11.jpeg", alt: "Projekt 7" },
  { src: "./22.jpeg", alt: "Projekt 8" },
  { src: "./33.jpeg", alt: "Projekt 9" },
  { src: "./44.jpeg", alt: "Projekt 10" },
  { src: "./55.jpeg", alt: "Projekt 11" },
  { src: "./66.jpeg", alt: "Projekt 12" },
  { src: "./77.jpeg", alt: "Projekt 13" },
  { src: "./88.jpeg", alt: "Projekt 14" },
];

export default function Projekte() {
  const navigate = useNavigate();
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with background image */}
      <div className="relative py-28 px-6 overflow-hidden">
        <img
          src="./77.jpeg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-lightBlue/85" />
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.button
            onClick={() => navigate("/")}
            className="text-white/70 hover:text-white transition-colors mb-6 flex items-center gap-2"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
            Zurück zur Startseite
          </motion.button>
          <motion.h1
            className="text-4xl md:text-6xl text-white font-bold"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Unsere Projekte
          </motion.h1>
          <motion.p
            className="text-white/70 mt-4 max-w-xl text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            Entdecken Sie unsere erfolgreich abgeschlossenen Bauprojekte.
          </motion.p>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, i) => (
            <motion.div
              key={i}
              className="overflow-hidden rounded-xl shadow-md group cursor-pointer bg-white"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              onClick={() => setSelectedImg(project.src)}
            >
              <div className="overflow-hidden aspect-[4/3]">
                <img
                  src={project.src}
                  alt={project.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="p-4">
                <p className="text-darkBlue font-semibold">{project.alt}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="max-w-7xl mx-auto px-6 pb-16 text-center">
        <motion.a
          href="tel:+491734317404"
          className="inline-block px-10 py-4 bg-darkBlue rounded-lg text-white font-medium text-lg hover:bg-blue-800 transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Kontakt
        </motion.a>
      </div>

      {/* Lightbox */}
      {selectedImg && (
        <motion.div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 cursor-pointer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          onClick={() => setSelectedImg(null)}
        >
          <motion.img
            src={selectedImg}
            alt="Projekt"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          />
          <button
            className="absolute top-6 right-6 text-white text-4xl hover:text-gray-300 transition-colors"
            onClick={() => setSelectedImg(null)}
          >
            &times;
          </button>
        </motion.div>
      )}
    </div>
  );
}
